import React, { useState } from 'react';
import SectionEdition, { Slot } from 'components/styleguide/section_edition/SectionEdition';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import SearchInput, { Item } from 'components/styleguide/search_input/SearchInput';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

type Option = { label: string; value: number };

interface RoleSectionProps {
  category_ids: number[];
  categories: Option[];
  url: string;
  required?: boolean;
}

const RoleSection: React.FC<RoleSectionProps> = ({
  category_ids,
  categories,
  url: url,
  required = false,
}) => {
  const initialItems = categories.filter(c => (category_ids || []).includes(c.value));
  const [selectedItems, setSelectedItems] = useState<Item[]>(initialItems);
  const [pendingItems, setPendingItems] = useState<Item[]>([]);

  const sheet = useEditableSheet({
    url: url,
    payloadKey: 'talent',
    onSuccess: () => {
      setSelectedItems(pendingItems);
    },
  });

  const hasAny = selectedItems.length > 0;
  const status = hasAny ? 'complete' : required ? 'mandatory' : 'missing';

  const handleAddClick = () => {
    sheet.open('Add roles', {});
  };

  const handleEditClick = () => {
    setPendingItems(selectedItems);
    sheet.open('Edit roles', {
      category_ids: selectedItems.map(i => i.value),
    });
  };

  const handleRolesChange = (updated: Item[]) => {
    setPendingItems(updated);
    sheet.handleFormChange('category_ids', updated.map(i => i.value));
  };

  return (
    <>
      <SectionEdition
        title="Role(s)"
        iconName="codeXml"
        context="talent"
        status={status}
        onEdit={handleEditClick}
        onAdd={hasAny ? undefined : handleAddClick}
      >
        {hasAny && (
          <Slot>
            <div className={styles.fieldGrid}>
              <div className={styles.field}>
                <p className={styles.value}>{selectedItems.map(i => i.label).join(', ')}</p>
              </div>
            </div>
          </Slot>
        )}
      </SectionEdition>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="talent"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <SearchInput
            initialItems={selectedItems}
            options={categories}
            label="Roles"
            placeholder="Search roles..."
            required={true}
            error={sheet.getError('category_ids')}
            onChange={handleRolesChange}
            context="talent"
          />
        </Sheet>
      )}
    </>
  );
};

export default RoleSection;
